module.exports = __webpack_public_path__ + "img/milad.93f7009b.jpg";